export class AsyasoftTimesRequest{
  reservation_date: string;
  pax: number;
  child: number;
  restaurant_id: number;
  token: string;
  constructor(reservationDate: string, pax: number, child: number, restaurantId: number, token: string){
    this.reservation_date = reservationDate;
    this.pax = pax;
    this.child = child;
    this.restaurant_id = restaurantId;
    this.token = token;
  }
}
